// src/pages/HomePage.jsx
import { Amplify } from "aws-amplify";
import { Authenticator, useAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { useNavigate } from "react-router-dom";
import bgImage from "../assets/bg2.jpg";
import { useEffect } from "react";

// Configure Amplify
Amplify.configure({
  Auth: {
    Cognito: {
      region: "us-east-1",
      userPoolId: "us-east-1_8jgQmSR2e",
      userPoolClientId: "1nmp730e48j8okdib94q4hnh3",
      authenticationFlowType: "USER_PASSWORD_AUTH",
    },
  },
});

// Redirect after sign-in
function RedirectOnSignIn({ navigate }) {
  const { route } = useAuthenticator((ctx) => [ctx.route]);

  useEffect(() => {
    if (route === "authenticated") {
      navigate("/search");
    }
  }, [route, navigate]);

  return null;
}

export default function HomePage() {
  const navigate = useNavigate();

  return (
    <div
      className="flex-1 flex items-center justify-center w-full"
      style={{
        minHeight: `calc(100vh - 12rem)`,
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "top",
        backgroundRepeat: "no-repeat",
      }}
    >
      <div className="relative z-10 max-w-6xl mx-auto bg-gray-100/70 backdrop-blur-sm rounded-xl shadow-lg pt-6 pb-6 flex md:flex-row flex-col items-stretch gap-12 px-12">
        {/* Left: Info */}
        <div className="flex-none md:flex-1 max-w-md text-gray-800 flex flex-col justify-center pt-12 pb-12">
          <h1 className="text-4xl md:text-4xl font-bold leading-tight mb-6">
            Find the Best Realtor Brokerages for Your Needs
          </h1>
          <p className="text-lg mb-6">
            Brokerage Insights helps you discover top-performing realtor
            brokerages based on their proven selling history.
            <br />
            Make confident decisions with data-backed rankings and detailed
            performance metrics.
          </p>
          <ul className="space-y-3 mb-8 text-gray-700">
            <li>✔️ Compare brokerages with intuitive visual rankings</li>
            <li>✔️ View detailed performance history</li>
            <li>✔️ Find the most suitable partner for your property</li>
          </ul>
        </div>

        {/* Right: Authenticator */}
        <div className="flex-1 w-full md:w-auto min-w-[300px] flex items-center justify-center">
          <Authenticator
            loginMechanisms={["email"]}
            hideSignUp={false}
            signUpAttributes={["given_name", "family_name"]}
          >
            <RedirectOnSignIn navigate={navigate} />
          </Authenticator>
        </div>
      </div>
    </div>
  );
}
